import {Component, OnInit} from '@angular/core';
import {Title} from '@angular/platform-browser';
import {NavigationEnd, Router} from '@angular/router';
import {WindowRefService} from './services/window-ref.service';
import {WebtrendsService} from './services/webtrends.service';
import * as mixpanel from 'mixpanel-browser';
import { AppConfig } from './app-config/app.config';
import * as uuid from 'uuid/v4';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
  private _window: any;
  map: Map<String, any>;
  uuidSession = uuid();

  private riskAssessmentProfilingUrl: string;

  public constructor(private titleService: Title,
                     private router: Router,
                     private windowRef: WindowRefService,
                     private webtrendsService: WebtrendsService,
                     private appConfig: AppConfig) {
    this.map = new Map<String, any>();
    this.map.set('/accounts', {'upid': 'SF-32251', 'title': 'User Registration'});
    this.map.set('/terms-and-conditions', {'upid': 'SF-99024', 'title': 'Terms And Conditions'});
    this.riskAssessmentProfilingUrl = appConfig.config.riskAssessmentProfilingUrl;
    this._window = windowRef.nativeWindow;

    this.titleService.setTitle('User Registration');

    this.router.events.subscribe((event: any) => {
      if (event instanceof NavigationEnd) {
        if (this._window.Webtrends !== undefined && typeof this._window.Webtrends.multiTrack !== 'undefined') {
          this.webtrendsService.multiTrack(this._window, this.router.url, this.getTitle(this.router.url), this.getUpid(this.router.url));
        }
      }
    });

    mixpanel.init(appConfig.config.mixPanelToken);
  }

  getUpid(href) {
    if (this.map.has(href)) {
      return this.map.get(href).upid;
    }
  }

  getTitle(href) {
    if (this.map.has(href)) {
      return this.map.get(href).title;
    }
  }

  addProfilingScriptElement() {
    const head = document.getElementsByTagName('head').item(0);
    const script = document.createElement('script');
    script.setAttribute('type', 'text/javascript');
    script.setAttribute('src', this.riskAssessmentProfilingUrl + this.uuidSession);
    head.appendChild(script);
  }

  ngOnInit() {
    this.addProfilingScriptElement();
  }
}
